<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Design system components
	import { Radio } from '@Shelly/shelly-design-system';
	import { capFirstChar } from 'src/helpers/utilities';
	//Types
	import type { PeripheralSwitchSettings } from 'src/types/Peripherals';

	let className = '';
	export { className as class };

	export let settings: PeripheralSwitchSettings;

	let selected = settings.initial_state;
	$: {
		// Skip saving if not changed to one of the valid options
		if (!['on', 'off', 'restore_last'].includes(selected)) {
			delete settings.initial_state;
		} else {
			settings.initial_state = selected;
		}
	}
</script>

<div class={className}>
	<Radio size="m" bind:selected value="on" id="radio-oo3gmk4">
		{capFirstChar(
			$format('power_on_default_on', {
				default: 'turn on',
			}),
		)}
	</Radio>
	<Radio size="m" bind:selected value="off" id="radio-8gaylgp">
		{capFirstChar(
			$format('label_action_turn_off', {
				default: 'turn off',
			}),
		)}
	</Radio>
	<Radio size="m" bind:selected value="restore_last" id="radio-vjt0qa4">
		{capFirstChar(
			$format('power_on_default_last', {
				default: 'Restore last known state of output/relay',
			}),
		)}
	</Radio>
</div>
